<template>
<span id="run-rating" v-if="shouldBeDisplayed()">
  <el-button v-if="!isDropDownItem" id="btn-run-rating" type="success" plain @click="dialogVisible = true" size="mini">
    {{ $t('customerService.shipment.runRating') }}
  </el-button>
  <el-dropdown-item v-if="isDropDownItem" id="close-billing-dropdown-item" @click.native="dialogVisible = true">
    <span class="more-actions-option">{{ $t('customerService.shipment.runRating') }}</span>
  </el-dropdown-item>
  <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('customerService.shipment.runRating')"
    :visible.sync="dialogVisible"
    width="30%"
    class="dialog-with-cols"
    :before-close="handleClose"
    append-to-body
  >
  <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
        <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
            <label class="span-small-list">{{ $t('customerService.shipment.ratingText') }}</label>
          </el-col>
      <el-row>
      </el-row>
      <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
        <el-form-item :label="$t('customerService.shipment.outboundDateFrom')" prop="outboundDateFrom" class="inline-input">
          <el-date-picker
            class="el-dropdown-new drop-sp date-dob width-100p-i"
            v-model="form.outboundDateFrom"
            format="MM/dd/yyyy"
            clearable
            type="date"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
        <el-form-item :label="$t('customerService.shipment.outboundDateTo')" prop="outboundDateTo" class="inline-input">
          <el-date-picker
            class="el-dropdown-new drop-sp date-dob width-100p-i"
            v-model="form.outboundDateTo"
            format="MM/dd/yyyy"
            clearable
            type="date"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
        <el-form-item :label="$t('customerService.shipment.consignee')" prop="consigneeAccountId" class="inline-input">
          <autocomplete
            :model.sync="form.consigneeAccountId"
            :shipperAccountId="null"
            labelFieldLastWithDash="number"
            classCss="width-100p-i"
            popperAppendToBody
            :url="consigneeUrl"
            labelField="name"
            valueField="id"
            ref="form-consignee-account-id"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-run-rating-button" @click="submitForm()" size="mini">{{ $t('customerService.shipment.runRating') }}</el-button>
      <el-button id="form-clear-button" @click="resetForm()" size="mini">{{ $t('common.clear') }}</el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import moment from 'moment';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  name: 'RunRating',
  components: { Autocomplete },
  props: {
    isDropDownItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['shipment']),
    consigneeUrl() {
      return apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE;
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        outboundDateTo: null,
        outboundDateFrom: null,
        reRunningRating: null,
        consigneeAccountId: null
      },
      formRules: {
        outboundDateTo: [
          { required: true, message: this.$t('customerService.shipment.error.outboundDateToRequired'), trigger: 'blur' }
        ],
        outboundDateFrom: [
          { required: true, message: this.$t('customerService.shipment.error.outboundDateFromRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    'form.outboundDateFrom': function updateTo(newVal) {
      // to work with changes in someOtherProp
      const newDayOfServiceFrom = moment(newVal);
      if (newDayOfServiceFrom.isAfter(moment(this.form.outboundDateTo))) {
        this.form.outboundDateTo = newVal;
      }
    },
    'form.outboundDateTo': function updateFrom(newVal) {
      const newDayOfServiceTo = moment(newVal);
      if (newDayOfServiceTo.isBefore(moment(this.form.outboundDateFrom))) {
        this.form.outboundDateFrom = newVal;
      }
    }
  },
  mounted() {
    if (this.shouldBeDisplayed() && this.isDropDownItem) {
      this.$emit('displayDropdown');
    }
  },
  methods: {
    shouldBeDisplayed() {
      return this.$can(this.permissions.BILLING.RUN_RATING);
    },
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
        this.selectConsignee();
      });
    },
    getDefaultDateFrom() {
      return this.shipment.actualFilters.outboundDateFrom || moment().add(-1, 'days').toDate();
    },
    getDefaultDateTo() {
      return this.shipment.actualFilters.outboundDateTo || this.shipment.actualFilters.outboundDateFrom
        || moment().add(-1, 'days').toDate();
    },
    handleClose(done) {
      this.resetForm();
      done();
    },
    async confirmValidationRating() {
      let globalConfirm = true;
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      const validationResponse = await this.$store.dispatch('shipment/validateRating', this.form).catch(() => {});
      if (validationResponse.data > 0) {
        globalConfirm = await this.$confirm(
          this.$t('customerService.shipment.reRunRatingConfirm')
            .replace('[shipmentsErrorOrRated]', validationResponse.data)
            .replace('[dateFrom]', moment(this.form.outboundDateFrom).format(constants.DATES.DEFAULT_DISPLAY_FORMAT))
            .replace('[dateTo]', moment(this.form.outboundDateTo).format(constants.DATES.DEFAULT_DISPLAY_FORMAT)),
          { confirmButtonText: this.$t('common.yes'), dangerouslyUseHTMLString: true }
        ).catch(() => {});
        if (globalConfirm) {
          this.form.reRunningRating = true;
        }
      }
      loading.close();
      return globalConfirm;
    },
    async submitForm() {
      // Validate Form.
      const validateForm = await this.$refs.form.validate().catch(() => {});
      if (!validateForm) {
        return;
      }

      Message.closeAll();

      // Check if exists shipments rated or error.
      const confirm = await this.confirmValidationRating();
      if (!confirm) {
        return;
      }

      const loading = this.$loading(constants.LOADING.RUN_RATING_CONFIG);

      try {
        const response = await this.$store.dispatch('shipment/runRating', this.form).catch(() => {});
        this.$message.success(response.message);
        this.resetForm();
        this.$store.dispatch('shipment/search', {});
        this.dialogVisible = false;
      } finally {
        loading.close();
      }
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.consigneeAccountId = null;
      this.$refs['form-consignee-account-id'].clearLocalModel();
      this.form.outboundDateTo = this.getDefaultDateTo();
      this.form.outboundDateFrom = this.getDefaultDateFrom();
    },
    selectConsignee() {
      if (this.shipment.actualFilters.consigneeAccountId) {
        this.form.consigneeAccountId = this.shipment.actualFilters.consigneeAccountId;
        this.$refs['form-consignee-account-id'].setLocalModel(this.shipment.actualFiltersLabels.consigneeAccountName);
      }
    }
  }
};
</script>
